/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/prop-types */
/* eslint-disable max-len */
import React, { useState } from "react";
import { useSelector } from "react-redux";
import "./MechanicsSummary.scss";
import { FiChevronUp } from "react-icons/fi";
import EditableConfigurationName from "../../../Common/components/EndPage/EditableConfigurationName/EditableConfigurationName";
import { orientationToDisplayString, axisSupportToDisplayString } from "../../store/data/cartesianData";
// import { selectMechanics } from "../../../store/slices/retrofit";
// import { selectMechanics } from "../../../store/slices/cartesian";

import { selectMechanics, selectCartesianCurrentStep, selectDynamics } from "../../store/slices/cartesian";
import t from "../../../Common/utils/translation/translator";

const InputSection = ({ mechanics }) => (
  <div className="InputSection flex-1 flex justify-between items-center mx-4">
    <div className="flex flex-col items-center">
      <div className="top-summary">{t("cartesian.ui.mechanics.user_input")}</div>
      <div className="top-summary">1/2</div>
    </div>
    <div>
      <div className="top-summary-elt underline decoration-gray-400 font-thin">
        {t("cartesian.ui.mechanics.axis_orientation")}
      </div>
      <div className="flex text-xs space-x-1">
        <div className="top-summary-values">
          {mechanics.carriageOrientation === "" ? "--" : orientationToDisplayString(mechanics.carriageOrientation)}
        </div>
      </div>
    </div>
    <div>
      <div className="top-summary-elt underline decoration-gray-400 font-thin">
        {t("cartesian.ui.mechanics.stroke_length")}
      </div>
      <div className="flex text-xs space-x-1">
        <div className="top-summary-values">{mechanics.strokeLength === "" ? "--" : mechanics.strokeLength} mm</div>
      </div>
    </div>
    <div>
      <div className="top-summary-elt underline decoration-gray-400 font-thin">
        {t("cartesian.ui.mechanics.axis_angle")}
      </div>
      <div className="flex text-xs space-x-1">
        <div className="top-summary-values">{mechanics.axisAngle === "" ? "--" : mechanics.axisAngle} °</div>
      </div>
    </div>
    {/* <div>
      <div className="top-summary-elt underline decoration-gray-400 font-thin">
        Double axis distance
      </div>
      <div className="flex text-xs space-x-1">
        <div className="top-summary-values">
          --mm
          {mechanics.doubleAxisDistance === ""
            ? "-- pcs"
            : mechanics.doubleAxisDistance}
        </div>
      </div>
    </div> */}
    <div>
      <div className="top-summary-elt underline decoration-gray-400 font-thin">
        {t("cartesian.ui.mechanics.axis_support")}
      </div>
      <div className="flex text-xs space-x-1">
        <div className="top-summary-values">
          {mechanics.axisSupport === "" ? "--" : axisSupportToDisplayString(mechanics.axisSupport)}
        </div>
      </div>
    </div>
    <div>
      <div className="top-summary-elt underline decoration-gray-400 font-thin">
        {t("cartesian.ui.mechanics.quantity_of_carriages")}
      </div>
      <div className="flex text-xs space-x-1">
        <div className="top-summary-values">
          {mechanics.quantityCarriages === "" ? "-- pcs" : mechanics.quantityCarriages}
        </div>
      </div>
    </div>
    {/* <div>
      <div className="top-summary-elt underline decoration-gray-400 font-thin">
        Transverse acceleration
      </div>
      <div className="flex text-xs space-x-1">
        <div className="top-summary-values">
          {mechanics.transverseAcceleration === ""
            ? "--"
            : mechanics.transverseAcceleration}{" "}
          m/s
          <sup>2</sup>
        </div>
      </div>
    </div> */}
  </div>
);

const ResultSection = ({ mechanics, dynamics }) => (
  <div className="flex-1 flex justify-between items-center mx-4">
    <div className="flex flex-col items-center">
      <div className="top-summary">{t("cartesian.ui.mechanics.user_input")}</div>
      <div className="top-summary">2/2</div>
    </div>
    {/* <div>
      <div className="top-summary-elt underline decoration-gray-400 font-thin">
        {t("cartesian.ui.mechanics.quantity_of_carriages")}
      </div>
      <div className="flex text-xs space-x-1">
        <div className="top-summary-values">
          {mechanics.quantityCarriages === ""
            ? "-- pcs"
            : mechanics.quantityCarriages}
        </div>
      </div>
    </div> */}
    <div className="">
      <div className="top-summary-elt underline decoration-gray-400 font-thin">
        {t("cartesian.ui.mechanics.distance_between_carriages")}
      </div>
      <div className="flex text-xs space-x-1">
        <div className="top-summary-values">
          {mechanics.distanceBetweenCarriages === "" ? "--" : mechanics.distanceBetweenCarriages} mm
        </div>
      </div>
    </div>
    <div className="">
      <div className="top-summary-elt underline decoration-gray-400 font-thin">
        {t("cartesian.ui.mechanics.connected_carriages")}
      </div>
      <div className="flex space-x-1">
        <div className="top-summary-values">{mechanics.carriageConnected ? "Yes" : "No"}</div>
      </div>
    </div>
    <div className="">
      <div className="top-summary-elt underline decoration-gray-400 font-thin">
        {t("cartesian.ui.dynamics.number_of_cycles_per_hour")}
      </div>
      <div className="flex text-xs space-x-1">
        <div className="top-summary-values">{dynamics?.cycleRunning?.numberOfCyclePerHour}</div>
      </div>
    </div>
    <div className="">
      <div className="top-summary-elt underline decoration-gray-400 font-thin">
        {t("cartesian.ui.dynamics.working_hours_per_day")}
      </div>
      <div className="flex text-xs space-x-1">
        <div className="top-summary-values">{dynamics?.cycleRunning?.workingHoursPerDay}</div>
      </div>
    </div>
    <div className="">
      <div className="top-summary-elt underline decoration-gray-400 font-thin">
        {t("cartesian.ui.dynamics.working_days_per_year")}
      </div>
      <div className="flex text-xs space-x-1">
        <div className="top-summary-values">{dynamics?.cycleRunning?.workingDaysPerYear}</div>
      </div>
    </div>
  </div>
);

const MechanicsSummary = ({ ...props }) => {
  const [result, setResult] = useState(false);
  const mechanics = useSelector(selectMechanics);
  const dynamics = useSelector(selectDynamics);

  return (
    <div className="MechanicsSummary ms-top z-[20] text-sm text-gray-600 py-1 shadow" {...props}>
      <div className="flex max-w-[20%] min-w-[20%]">
        <EditableConfigurationName smallInput selectCartesianCurrentStep={selectCartesianCurrentStep} />
      </div>
      {result ? <ResultSection mechanics={mechanics} dynamics={dynamics} /> : <InputSection mechanics={mechanics} />}
      <div className="p-2 border-l border-solid">
        <div
          className="ms-elem-chevron rounded-sm cursor-pointer hover:bg-blue-100 transition-all duration-75"
          onClick={() => setResult(!result)}
        >
          <FiChevronUp className={`transition-all duration-200 ${result ? "" : "transform rotate-180"}`} />
        </div>
      </div>
    </div>
  );
};
export default MechanicsSummary;
